// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1-XC1","inputWrap":"styles_inputWrap__2Tb1t","input":"styles_input__2WVGs"};